const certificateView = {
  path: 'certificateView/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/certificateView'], resolve)
}
export default certificateView



// WEBPACK FOOTER //
// ./src/router/pages/student_user/certificateView/index.js